enum OrderStatusEnum {
  RESERVATION_REQUEST = 'reservation_request',
  PHOTOMATCH_IN_ANALYSIS = 'photomatch_in_analysis',
  WAITING_PAYMENT = 'waiting_payment',
  WAITING_PAYMENT_TRANSPORT = 'waiting_payment_transport',
  WAITING_PAYMENT_VERIFICATION = 'waiting_payment_verification',
  SEND_CONTRACT = 'send_contract',
  WAITING_SIGNATURE = 'waiting_signature',
  CONTRACT_SIGNED = 'contract_signed',
  REQUEST_FOR_FORM = 'request_for_form',
  WAITING_SEND_REQUEST = 'waiting_send_request',
  SEND_SCHEDULED = 'send_scheduled',
  SENDED = 'sended',
  DELIVERED = 'delivered',
  RESERVATION_FEE = 'reservation_fee',
  MAINTENANCE_FEE = 'maintenance_fee',
  GENETICS = 'genetics',
  CUSTOM_IMPORT = 'custom_import',
  PENDING = 'pending',
  CART = 'cart',
  AFTER_SALES = 'after_sales',
  CANCELED = 'canceled',
}

export default OrderStatusEnum